module.exports = __webpack_public_path__ + "img/escritorio-silla.bf06def6.svg";